import { useState, useEffect, useCallback } from 'react';
import { apiFetch } from '../api/client';

export function useReviews() {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchReviews = useCallback(() => {
    setLoading(true);
    apiFetch('/reviews.php')
      .then(data => {
        setReviews(data.reviews || []);
        setLoading(false);
      })
      .catch(e => {
        setError(e.message);
        setLoading(false);
      });
  }, []);

  useEffect(() => { fetchReviews(); }, [fetchReviews]);

  return { reviews, loading, error };
}
